module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 suggestions.forEach( product => { 
__p+='\n<a href="/shop-suche/?'+
((__t=( new URLSearchParams( Object.assign( {
	fromProductSuggest: 'true',
	sku: product.sku,
}, userInput ? { query: userInput, userInput } : {} ) ).toString() ))==null?'':__t)+
'" class="mdl_search__suggestions-product"\n	';
 if ( 'dataSuggest' in product ) { 
__p+=' data-suggest="'+
((__t=( product.dataSuggest ))==null?'':__t)+
'"';
 } 
__p+='\n	';
 if ( 'slotId' in product ) { 
__p+=' data-slot-id="'+
((__t=( product.slotId ))==null?'':__t)+
'"';
 } 
__p+='\n>\n	<div class="mdl_search__suggestions-product-image-wrapper">\n		<img class="mdl_search__suggestions-product-image" src="'+
((__t=( product.ImageURL ))==null?'':__t)+
'" alt="'+
((__t=( [ product.brand || '', product.name || '' ].join( ' | ' ) ))==null?'':__t)+
'" loading="lazy" width="192" height="256">\n	</div>\n	<div class="mdl_search__suggestions-product-data">\n		<div class="mdl_search__suggestions-product-brand">'+
((__t=( mark( product.brand ) ))==null?'':__t)+
'</div>\n		<div class="mdl_search__suggestions-product-name">'+
((__t=( mark( product.name ) ))==null?'':__t)+
'</div>\n	</div>\n</a>\n';
 } ) 
__p+='\n\n';
 if ( showAll ) { 
__p+='\n<div class="mdl_search__suggestions-allproducts en_hidden_desktop_down">\n	<button type="submit" form="header_search__form" class="en_button en_button--size_small">'+
((__t=( window.StringTranslation ? window.StringTranslation.get( 'SHOW_ALL' ) : 'Alle anzeigen' ))==null?'':__t)+
'</button>\n</div>\n';
 } 
__p+='\n';
}
return __p;
};
